// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

console.log("!!! INDEX.JS IS LOADING !!!");

import { application } from "./application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import StimulusReflex from "stimulus_reflex";
import consumer from "../channels/consumer";
import controller from "../controllers/application_controller";
import NestedForm from "stimulus-rails-nested-form";
import GeolocationController from "./geolocation_controller";
import UppyImageEditorController from "./uppy_image_editor_controller";
application.register("geolocation", GeolocationController);
application.register("uppy-image-editor", UppyImageEditorController);
console.log("Manually registered uppy-image-editor controller");
const context = require.context(".", true, /_controller\.js$/);
const definitions = definitionsFromContext(context);
console.log("Controller definitions found:", definitions);
console.log(
  "Uppy definition:",
  definitions.find((d) => d.identifier === "uppy-image-editor")
);
console.log("About to call application.load()...");
try {
  application.load(definitions);
  console.log("application.load() completed successfully");
} catch (error) {
  console.error("Error during application.load():", error);
}
console.log("Stimulus application:", application);
console.log("Registered controllers:", application.router.modulesByIdentifier);
console.log(
  "Uppy registered?",
  application.router.modulesByIdentifier.has("uppy-image-editor")
);
console.log(
  "All registered identifiers:",
  Array.from(application.router.modulesByIdentifier.keys())
);
try {
  StimulusReflex.initialize(application, { consumer });
  console.log("StimulusReflex initialized successfully");
} catch (error) {
  console.warn("StimulusReflex initialization failed:", error.message);
}
// List all controller names
const controllerNames = Array.from(
  application.router.modulesByIdentifier.keys()
);
console.log("All controller names:", controllerNames);
console.log(
  "Is cart-summary registered?",
  controllerNames.includes("cart-summary")
);
console.log("Is cart-item registered?", controllerNames.includes("cart-item"));
StimulusReflex.initialize(application, { consumer });
console.log("StimulusReflex initializeadadfd");
application.register("nested-form", NestedForm);
console.log("is this workingadf");

console.log("invite accordion controller registered");
if (process.env.RAILS_ENV === "development") {
  import("radiolabel").then((Radiolabel) =>
    application.register("radiolabel", Radiolabel.default)
  );
}


// New Manually Registered Controller - Givsum3
import GvSplideSliderController from "./gv_splide_slider_controller";
import StepperController from "./stepper_controller";
import GlobalModalController from "./global_modal_controller";
import Gv3HeaderController from "./givsum3_header_controller"

application.register("gv-splide-slider", GvSplideSliderController);
application.register("stepper", StepperController);
application.register('global-modal', GlobalModalController)
application.register("gv3-header", Gv3HeaderController)